import R from "ramda";
import { BOOTSTRAP_ACCOUNT_SETTINGS } from "actions/bootstrap-actions";
import {
  SET_ACCOUNT_DETAILS,
  SET_PLAN_TYPE_DISPLAY,
  SET_PLANS,
  UPDATE_PLAN,
  SET_BILLING_HISTORY,
  SET_PAGINATION_LIMIT,
  NEXT_PAGE,
  PREVIOUS_PAGE,
  SET_BILLING_DETAILS,
  UPDATE_BILLING_DETAILS,
  SET_LOCALES,
  SET_ACCOUNT_USERS,
  USER_REMOVED,
  USER_CREATED,
  SET_INVITE_USER_VISIBILITY,
  NO_BILLING_DETAILS,
  SET_REMOVE_SELF_VISIBILTIY,
  SET_DOC_RETURN_STATUS,
  CHANGE_PLAN_LOADING,
  CHANGE_PLAN_LOADING_STOP,
  SET_PENDING_PLAN,
  SET_CANCEL_SUBSCRIPTION_VISIBILITY,
  SHOW_UPGRADE_DOWNGRADE_MODAL,
  HIDE_UPGRADE_DOWNGRADE_MODAL,
  UPDATE_ACCOUNT_NAME_AND_EMAIL,
  UPDATE_ADDRESS,
  UPDATE_CLT_SETTINGS,
  DOCUMENT_RETURN_LOADING,
  DOCUMENT_RETURN_LOADING_STOP
} from "actions/account-settings-actions";

export const initialState = {
  address: null,
  billingDetails: null,
  cancelDate: null,
  currency: "AUD",
  docReturn: false,
  dropboxEmail: null,
  emailPin: "",
  invoices: [],
  isAccountUsersLoading: true,
  isNoBillingDetails: false,
  isBillingDetailsLoading: true,
  isBillingHistoryLoading: true,
  isCancelSubscriptionVisible: false,
  isChangePlanLoading: false,
  isDocumentReturnLoading: false,
  isInviteUserVisible: false,
  isLocalesLoading: true,
  isLoading: true,
  isPlansLoading: true,
  isRemoveSelfVisible: false,
  isUpgradeDowngradeVisible: false,
  label: "",
  locale: "en-AU",
  maxUsers: null,
  pagination: {
    displayInvoices: [],
    invoicePages: [],
    pageNumber: 1,
    limit: 20
  },
  pendingPlan: null,
  plan: null,
  planDetails: null,
  planDisplay: "monthly",
  plans: [],
  showUniversalCategorySet: true,
  shredDocuments: false,
  slug: "",
  supportedLocales: [],
  users: [],
  vat: "10.00",
  vip: false
};

export const accountSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_ACCOUNT_SETTINGS:
      return R.merge(state, action.data.accountSettings);
    case SET_ACCOUNT_DETAILS:
      return stateForSetAccountDetails(state, action);
    case SET_PLAN_TYPE_DISPLAY:
      return R.merge(state, { planDisplay: action.data.type });
    case SET_PLANS:
      return R.merge(state, { plans: action.data.plans });
    case UPDATE_PLAN:
      return R.merge(state, { planDetails: action.data.plan, isCancelSubscriptionVisible: false });
    case SET_BILLING_HISTORY:
      return stateForSetBillingHistory(state, action);
    case SET_PAGINATION_LIMIT:
      return stateForSetPaginationLimit(state, action.data.limit);
    case NEXT_PAGE:
      return stateForNextPage(state);
    case PREVIOUS_PAGE:
      return stateForPreviousPage(state);
    case SET_BILLING_DETAILS:
      return R.merge(state, { isBillingDetailsLoading: false, billingDetails: action.data.billingDetails });
    case UPDATE_BILLING_DETAILS:
      return R.set(R.lensPath(["billingDetails", action.data.field]), action.data.payload, state);
    case SET_LOCALES:
      return R.merge(state, { supportedLocales: action.data.supportedLocales, isLocalesLoading: false });
    case SET_ACCOUNT_USERS:
      return R.merge(state, {
        isAccountUsersLoading: false,
        maxUsers: action.data.maxUsers,
        users: action.data.users
      });
    case USER_REMOVED:
      return stateForRemoveUser(state, action);
    case USER_CREATED:
      return R.merge(state, { users: R.append(action.data.newUser, state.users) });
    case SET_INVITE_USER_VISIBILITY:
      return R.merge(state, { isInviteUserVisible: action.data.visible });
    case NO_BILLING_DETAILS:
      return R.merge(state, { isNoBillingDetails: true, isBillingDetailsLoading: false });
    case SET_REMOVE_SELF_VISIBILTIY:
      return R.merge(state, { isRemoveSelfVisible: action.data.visible });
    case SET_DOC_RETURN_STATUS:
      return R.merge(state, { docReturn: action.data.isOn });
    case CHANGE_PLAN_LOADING:
      return R.merge(state, { isChangePlanLoading: true });
    case CHANGE_PLAN_LOADING_STOP:
      return R.merge(state, { isChangePlanLoading: false });
    case SET_PENDING_PLAN:
      return stateForSetPendingPlan(state, action);
    case SET_CANCEL_SUBSCRIPTION_VISIBILITY:
      return R.merge(state, { isCancelSubscriptionVisible: action.data.visible });
    case SHOW_UPGRADE_DOWNGRADE_MODAL:
      return R.merge(state, { isUpgradeDowngradeVisible: true, plan: action.data.plan });
    case HIDE_UPGRADE_DOWNGRADE_MODAL:
      return R.merge(state, { isUpgradeDowngradeVisible: false, plan: null });
    case UPDATE_ACCOUNT_NAME_AND_EMAIL:
      return R.merge(state, {
        label: action.data.settings.label,
        slug: action.data.settings.slug,
        emailPin: action.data.settings.emailPin
      });
    case UPDATE_ADDRESS:
      return R.merge(state, { address: action.data.newAddress });
    case UPDATE_CLT_SETTINGS:
      return R.merge(state, {
        currency: action.data.newSettings.currency,
        locale: action.data.newSettings.locale,
        vat: action.data.newSettings.vat
      });
    case DOCUMENT_RETURN_LOADING:
      return R.merge(state, { isDocumentReturnLoading: true });
    case DOCUMENT_RETURN_LOADING_STOP:
      return R.merge(state, { isDocumentReturnLoading: false });
    default:
      return state;
  }
};

const stateForSetBillingHistory = (state, action) => {
  const newInvoices = action.data.invoices.filter(invoice => invoice.total !== 0);
  const newPagination = R.clone(state.pagination);
  const invoicePages = R.splitEvery(newPagination.limit, newInvoices);
  newPagination.displayInvoices = invoicePages[newPagination.pageNumber - 1];
  newPagination.invoicePages = invoicePages;
  return R.merge(state, {
    isBillingHistoryLoading: false,
    invoices: action.data.invoices,
    pagination: newPagination
  });
};

const stateForSetAccountDetails = (state, action) => (
  R.merge(state, {
    address: action.data.accountDetails.address,
    dropboxEmail: action.data.accountDetails.dropboxEmail,
    emailPin: action.data.accountDetails.emailPin,
    isLoading: false,
    label: action.data.accountDetails.label,
    planDetails: action.data.planDetails,
    slug: action.data.accountDetails.slug,
    vip: action.data.accountDetails.vip
  })
);

const stateForSetPaginationLimit = (state, limit) => {
  const newPagination = R.clone(state.pagination);
  const invoicePages = R.splitEvery(limit, state.invoices);
  newPagination.displayInvoices = invoicePages[newPagination.pageNumber - 1];
  newPagination.invoicePages = invoicePages;
  newPagination.limit = limit;
  return R.merge(state, { pagination: newPagination });
};

const stateForNextPage = (state) => {
  const { pagination, invoices } = state;
  const currentPage = pagination.pageNumber;
  const maxPage = Math.ceil(invoices.length / pagination.limit);

  if (currentPage >= maxPage) {
    return state;
  }
  return R.merge(state, {
    pagination: R.merge(state.pagination, {
      displayInvoices: state.pagination.invoicePages[currentPage],
      pageNumber: currentPage + 1
    })
  });
};

const stateForPreviousPage = (state) => {
  const currentPage = state.pagination.pageNumber;
  if (currentPage <= 1) {
    return state;
  }
  return R.merge(state, {
    pagination: R.merge(state.pagination, {
      displayInvoices: state.pagination.invoicePages[currentPage - 2],
      pageNumber: currentPage - 1
    })
  });
};

const stateForRemoveUser = (state, action) => {
  const newUsers = state.users.filter(user => user.id !== action.data.userId);
  return R.merge(state, { users: newUsers });
};

const stateForSetPendingPlan = (state, action) => (
  R.merge(state, {
    cancelDate: action.data.cancelDate,
    pendingPlan: action.data.pendingPlan,
    isPlansLoading: false
  })
);



// WEBPACK FOOTER //
// ./src/js/reducers/account-settings-reducer.js